import React from "react";
import { useNavigate, Link } from "react-router-dom";
import "./login.css";

/**
 * BE Sarawak Staff Portal login (ported from the prototype).
 * Authentication is via the BESarawak Microsoft Azure account — there is no
 * local email/password form. Password recovery is handled by Azure, so the
 * forgot/reset routes show a short note pointing back to Azure sign-in.
 */
const AuthPage = ({ mode }) => {
  const navigate = useNavigate();

  const handleAzureLogin = () => {
    // TODO: replace with the real MSAL / Azure AD redirect once wired to the backend.
    navigate("/dashboard");
  };

  return (
    <div className="bes-login">
      <div className="bes-login-card">
        <div className="bes-login-header">
          <img src="/logo.png" alt="BE Sarawak Logo" className="bes-login-logo" />
          <h2>{mode === "forgot" ? "Password Managed by Azure" : "Welcome Back"}</h2>
          <p>
            {mode === "forgot"
              ? "Your password is managed by your BESarawak Microsoft Azure account. Reset it through Microsoft, then sign in again."
              : "Use your BESarawak Microsoft Azure account to access the staff portal."}
          </p>
        </div>

        <div className="bes-login-actions">
          {mode === "forgot" ? (
            <Link to="/login" className="bes-btn-azure">
              <i className="ri-arrow-left-line" /> Back to login
            </Link>
          ) : (
            <button type="button" className="bes-btn-azure" onClick={handleAzureLogin}>
              <i className="ri-microsoft-fill" /> Login with Microsoft Azure
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
